<template>
  <div class="mt-20">
    <h5 class="text-bold">Item Scan History</h5>
    <strong class="mt-20 mb-10">Item Ids :</strong>
    <div class="grid-body p-0" v-if="history">
        <div v-for="(group, productionItemId) in groupedHistory" :key="productionItemId">
          <div class="scan-item">
            <div class="text-bold">
              <a class="fabric-toggle" @click="toggleGroupRows(productionItemId)">
                <span v-if="itemId == productionItemId" class="fa fa-chevron-down"></span>
                <span v-else class="fa fa-chevron-right"></span>
              </a>
            </div>
            <div>
              #{{ productionItemId }}
            </div>
          </div>
          <div v-for="item in groupedHistory" :key="item[0].index">
            <div v-if="productionItemId == item[0].production_item_id && itemId == item[0].production_item_id">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="historyItem in item" :key="historyItem.index">
                    <td>{{ historyItem.id }}</td>
                    <td>{{ historyItem.status }}</td>
                    <td>{{ dateTimeFormat(historyItem.updated_at) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["history"],
  data() {
    return {
      itemId: 0,
    };
  },
  methods: {
    dateTimeFormat(dateTime) {
      if (dateTime) {
        return moment(dateTime).utc().format("MMM DD, YYYY HH:mm:ss");
      }
    },

    toggleGroupRows(productionItemId) {
      this.itemId = (this.itemId != productionItemId) ? productionItemId : 0;
    },
  },
  computed: {
    groupedHistory() {
      const grouped = {};
      this.history.forEach((item, index) => {
        const productionItemId = item.production_item_id;
        if (!grouped[productionItemId]) {
          grouped[productionItemId] = [];
        }
        grouped[productionItemId].push({
          ...item,
          index,
        });
      });
      return grouped;
    },
  },
};
</script>

<style scoped>
  .scan-item{
    width: 100%;
    display: flex;
    gap: 10px;
    padding: 15px;
    border: 0.4px solid #8e898990;
    margin: 10px 0;
    min-width: 100px;
  }
</style>
